import { EmptyGuid } from "../../../utils/constants";

export interface IFundSource {
    fundSourceId: string;
    fundSourceCode: string;
    statusId: string;
    status: string;
    fundSourceDescrip: string;
    campGrpId: string;
    titleIv?: boolean;
    awardTypeId?: number;
    awardYear?: string;
    advFundSourceId?: number;
    cutoffDate?: Date;
    ipedsvalue?: number;
    isFinancialAidAward?: boolean;
}

export function createDefaultFundSource(): IFundSource {
    return {
        fundSourceId: EmptyGuid,
        fundSourceCode: '',
        statusId: '',
        status: '',
        fundSourceDescrip: '',
        campGrpId: '',
        titleIv: false,
        awardTypeId: undefined,
        awardYear: '',
        advFundSourceId: undefined,
        cutoffDate: undefined,
        ipedsvalue: undefined,
        isFinancialAidAward: false,
    };
}